import {initPlaceholders} from "../helpers/inputs";
import {calculateFullPrice} from "./orderInfoTemplates";

export function renderSubmitOrderTickets(WIDGET_DATA, $domElements) {
    let result = '';


    WIDGET_DATA.chosenTickets.forEach((ticket,index) => {
        const placeId = ticket.id;
        const placeNumber = ticket.placeNumber;
        const rowNumber = ticket.rowNumber;
        let firstNameFirstInputClass = '';
        let lastNameFirstInputClass = '';

        if(index === 0){
            firstNameFirstInputClass = 'ticket-system__first-submit-order-input';
            lastNameFirstInputClass = 'ticket-system__second-submit-order-input';
        }

        result += `
            <div class="ticket-system__submit-order-ticket" data-submit-order-ticket-id='${placeId}'>
                <div class="ticket-system__submit-order-ticket-info">
                    <div class="ticket-system__submit-order-ticket-info-item">
                        <div class="ticket-system__submit-order-ticket-info-item-description">Сектор</div>
                        <div class="ticket-system__submit-order-ticket-info-item-value">${WIDGET_DATA.chosenSector.name}</div>
                    </div>
                    <div class="ticket-system__submit-order-ticket-info-item">
                        <div class="ticket-system__submit-order-ticket-info-item-description">Ряд</div>
                        <div class="ticket-system__submit-order-ticket-info-item-value">${rowNumber}</div>
                    </div>
                     <div class="ticket-system__submit-order-ticket-info-item">
                        <div class="ticket-system__submit-order-ticket-info-item-description">Место</div>
                        <div class="ticket-system__submit-order-ticket-info-item-value">${placeNumber}</div>
                    </div>
                </div>
                <div class="ticket-system__submit-order-ticket-inputs">
                     <div class="ticket-system__submit-order-tickets-input-block">
                        <div class="ticket-system__submit-order-input-title">Фамилия</div>
                        <label class="field classic">
                            <input type="text"
                                   class="input-text input-mask placeholder validate ${lastNameFirstInputClass}"
                                   style="text-transform: capitalize;"
                                   data-placeholder="Фамилия"
                                   data-validate="required"
                                   autocomplete="off" 
                                   autocorrect="off"
                                   autocapitalize="none" 
                            >
                            <p class="error-message"></p>
                        </label>
                     </div>
                     <div class="ticket-system__submit-order-tickets-input-block">
                        <div class="ticket-system__submit-order-input-title">Имя</div>
                        <label class="field classic">
                            <input type="text"
                                   class="input-text input-mask placeholder validate ${firstNameFirstInputClass}"
                                   style="text-transform: capitalize;"
                                   data-placeholder="Имя"
                                   data-validate="required"
                                   autocomplete="off" 
                                   autocorrect="off"
                                   autocapitalize="none"
                            >
                            <p class="error-message"></p>
                        </label>
                     </div>
                </div>
            </div>`;
    });

    calculateFullPrice(WIDGET_DATA);

    $domElements.submitOrderInputsWrapper.html(result);
    initPlaceholders();
}